<template>
    <div>
        <div class="info-box">
            <courseinfo ref="courseinfo" :intoType='intoType' :intoCourseId='this.$route.query.courseId'></courseinfo>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>提前考信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p>考试方式：</p>
                    <!-- <a-input class="input" v-model="info.ksfs"/> -->
                    <a-select default-value="论文" v-model="info.ksfs" class="input" :disabled="type=='look'">
                        <a-select-option value = '论文'>
                        论文
                        </a-select-option>
                        <a-select-option value = '试卷'>
                        试卷
                        </a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>监考教师：</p>
                    <a-select
                        :disabled="type=='look'"
                        mode="multiple"
                        style="width: 100%"
                        v-model="jklsArr"
                        placeholder="请选择老师"
                        @change="handleChange"
                        class="input"
                    >
                        <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherId+'-'+item.teacherName" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>监考时间：</p>
                    <a-range-picker style='width:30rem' format="YYYY-MM-DD HH:mm" :value="jksjArr" :disabled="type=='look'" @change="onChange" show-time/>
                    <!-- <a-input class="input" :disabled="type=='look'" v-model="info.jksj"/> -->
                </div>
                <div class="input-box">
                    <p>监考教室：</p>
                    <a-input class="input" :disabled="type=='look'" v-model="info.jkjs"/>
                </div>
                
            </div>
            <div class="info-main">
                <div class="input-box">
                    <p></p>
                    <a class="input" href="https://cj.shu.edu.cn">教室申请</a>
                </div>
                <div class="input-box">
                    <a class="explain" href="#">《教务管理系统中借用教室说明》</a>
                </div>
                <div class="input-notes">
                    <div class="note-title">路径：</div>
                    <div class="notes">上海大学本科教务管理系统<a-icon type="arrow-right" />教师门户<a-icon type="arrow-right" />教室借用</div>
                </div>
            </div>
            
        </div>
        <div class="btn-box">
            <a-button type="primary" v-if="type!='look'" @click="sub">提交</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/undergraduate/culture/examsEarlyInfo'
    import courseinfo from './courseInfo'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    export default {
        name: 'teacher',
        components: {
            courseinfo
        },
        data () {
            return {
                type:'',
                info:{
                    kcbId:null,
                    ksfs:null,
                    jkls:'',
                    jksj:null,
                    jkjs:null
                },
                bilingualArray:['外语讲课、外语板书、使用外语教材','中文讲课、外语板书、使用外语教材','中文讲课、中文板书、使用外语教材'],
                intoType:'into',
                intoCourseId:'',
                jsArr:[],
                jklsArr:[],
                jksjArr:[]
            }
        },
        mounted () {
            this.type=this.$route.query.type;
            this.info.kcbId=this.$route.query.courseId;
            if(this.type=='add'){
                // info(this.$route.query.courseId).then(res=>{
                //     this.info.kcbId=this.$route.query.courseId;
                //     this.info.ksfs=res.data.ksfs;
                //     this.info.jkls=res.data.jkls;
                //     this.info.jksj=res.data.jksj;
                //     this.info.jkjs=res.data.jkjs;
                // })
            }else{
                setTimeout(()=>{
                    info(this.$route.query.courseId).then(res=>{
                        this.info=res.data;
                        this.jklsArr=res.data.jkls.split(',');
                        this.jksjArr=res.data.jksj.split('~');
                    })
                },500)
            }

            getTeacher().then(res=>{
                this.jsArr=res.data;
            })

        },
        methods:{
            onChange(date, dateString) {
                this.jksjArr=dateString
            },
            handleChange(value) {
                this.jklsArr = value
            },
            sub(){
                this.info.jksj=this.jksjArr[0]+'~'+this.jksjArr[1]
                this.info.jkls = this.jklsArr.toString()
                var isSub=true;
                var arr=['kcbId','ksfs']
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                if(isSub){
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增提前考成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改提前考成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写考试方式！',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box .explain{
        margin-left: 7rem;
        text-align: left;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }

    .info-main .input-box .range-date{
        width: calc(100% - 8rem);
    }

    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .standard{
        width: 28px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 200px;
        text-align: center;
        border-radius: 6px 0 0 6px !important;
        z-index: 0;
        pointer-events: auto;
        cursor: pointer;
        color: rgb(255, 255, 255);
        background-color: #245086;
        opacity: 0.8;
        padding: 2px 0px 0px 0px;
    }

    .standard:hover{
        opacity: 1;
    }

    .info-main .input-maxbox{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-maxbox p{
        width: 10rem;
        text-align: right;
    }

    .info-main .input-maxbox .textarea{
        width: calc(100% - 10rem);
    }

    .info-main .input-notes{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-notes .notes{
        width: calc(100% - 10rem);
        text-align: left;
        font-size: 0.9rem;
    }

    .info-main .input-notes .note-title{
        width: 10rem;
        text-align: right;
        font-size: 0.9rem;
        font-weight: bolder;
        color: black;
    }

</style>
